import { Button, Stack } from '@mui/material';
import { PlusIcon } from '@phosphor-icons/react';
import {
  FlowPatientDataStoreCaseSensitivity,
  FlowPatientDataStoreFilterMatchRule,
  type FlowPatientDataStoreFilterOperation,
  FlowPatientDataStoreFilterOperator,
} from 'flow-schema';
import * as uuid from 'uuid';

import { FilterListBlockFilterOperationCard } from './FilterOperationCard.tsx';
import { useReactFlowViewContext } from '../../../context/context.tsx';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField.ts';

function getDefaultFilterOperationField(): FlowPatientDataStoreFilterOperation {
  return {
    id: uuid.v4(),
    fieldToFilter: '',
    value: '',
    operator: FlowPatientDataStoreFilterOperator.Equals,
    caseSensitive: FlowPatientDataStoreCaseSensitivity.IgnoreCase,
  };
}

export function FilterOperationFields(props: {
  setFilterMatchRule: (filterMatchRule: FlowPatientDataStoreFilterMatchRule) => void;
}) {
  const { setFilterMatchRule } = props;
  // Provide a default empty array if conditions is null or undefined from previously configured blocks
  const { value: filterOperations = [], setValue } = useSelectedNodeField<
    FlowPatientDataStoreFilterOperation[]
  >('config.baseFilters.filterConfig.filterOperations');
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack gap={2}>
      {filterOperations.map((filterOperation, index) => {
        return (
          <FilterListBlockFilterOperationCard
            key={filterOperation.id}
            fieldNamePrefix={`config.baseFilters.filterConfig.filterOperations.${index}`}
            onDelete={() => {
              setValue(filterOperations.filter((value) => value.id !== filterOperation.id));
            }}
            filterOperation={filterOperation}
          />
        );
      })}
      <Button
        variant="outlined"
        onClick={() => {
          if (filterOperations.length === 0) {
            setFilterMatchRule(FlowPatientDataStoreFilterMatchRule.All);
          }
          setValue([...filterOperations, getDefaultFilterOperationField()]);
        }}
        sx={{
          alignSelf: 'flex-start',
          gap: 1,
        }}
        disabled={!isEditable}
      >
        <PlusIcon size={16} />
        Add condition
      </Button>
    </Stack>
  );
}
